module.exports = __webpack_public_path__ + "img/svg/background-deposit-modal.4bc70dcc535d7acb8808432e3e89c1df.svg";